// router/index.js
import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store'; // Vuex ストアをインポート

// ログイン
import Login from '../views/LoginPage.vue';
import SsoEntryPage from '../views/SsoEntryPage.vue';

// ホーム
import Home from '../views/Homes/HomeView.vue';

// ユーザ情報
import UserList from '../views/Users/UserList.vue';
import UserCreate from '../views/Users/UserCreate.vue';
import UserEdit from '../views/Users/UserEdit.vue';
import UserDetail from '../views/Users/UserDetail.vue';

// 顧客情報
import CustomerList from '../views/Customers/CustomerList.vue';
import CustomerCreate from '../views/Customers/CustomerCreate.vue';
import CustomerEdit from '../views/Customers/CustomerEdit.vue';
import CustomerDetail from '../views/Customers/CustomerDetail.vue';

// 顧客担当者情報
import CustomerRepresentativeList from '../views/CustomerRepresentatives/CustomerRepresentativeList.vue';
import CustomerRepresentativeCreate from '../views/CustomerRepresentatives/CustomerRepresentativeCreate.vue';
import CustomerRepresentativeEdit from '../views/CustomerRepresentatives/CustomerRepresentativeEdit.vue';
import CustomerRepresentativeDetail from '../views/CustomerRepresentatives/CustomerRepresentativeDetail.vue';

// 建物情報
import BuildingList from '../views/Buildings/BuildingList.vue';
import BuildingCreate from '../views/Buildings/BuildingCreate.vue';
import BuildingEdit from '../views/Buildings/BuildingEdit.vue';
import BuildingDetail from '../views/Buildings/BuildingDetail.vue';

// 建物種別情報
import BuildingTypeList from '../views/BuildingTypes/BuildingTypeList.vue';
import BuildingTypeCreate from '../views/BuildingTypes/BuildingTypeCreate.vue';
import BuildingTypeEdit from '../views/BuildingTypes/BuildingTypeEdit.vue';
import BuildingTypeDetail from '../views/BuildingTypes/BuildingTypeDetail.vue';

// 業者情報
import VendorList from '../views/Vendors/VendorList.vue';
import VendorCreate from '../views/Vendors/VendorCreate.vue';
import VendorEdit from '../views/Vendors/VendorEdit.vue';
import VendorDetail from '../views/Vendors/VendorDetail.vue';

// 業種区分情報
import BusinessClassificationList from '../views/BusinessClassifications/BusinessClassificationList.vue';
import BusinessClassificationCreate from '../views/BusinessClassifications/BusinessClassificationCreate.vue';
import BusinessClassificationEdit from '../views/BusinessClassifications/BusinessClassificationEdit.vue';

// 見積小分類情報
import EstimateSubcategoryList from '../views/EstimateSubcategories/EstimateSubcategoryList.vue';
import EstimateSubcategoryCreate from '../views/EstimateSubcategories/EstimateSubcategoryCreate.vue';
import EstimateSubcategoryEdit from '../views/EstimateSubcategories/EstimateSubcategoryEdit.vue';

// 見積管理
import EstimateList from '../views/Estimates/EstimateList.vue';
import EstimateCreate from '../views/Estimates/EstimateCreate.vue';
import EstimateEdit from '../views/Estimates/EstimateEdit.vue';
import EstimateDetail from '../views/Estimates/EstimateDetail.vue';
import EstimateWorkConversionPreview from '../views/Estimates/EstimateWorkConversionPreview.vue';

// 年間予定業務
import MonthlyAnnualWorkScheduleList from '../views/AnnualWorkSchedules/MonthlyAnnualWorkScheduleList.vue';
import CustomerBuildingList from '../views/AnnualWorkSchedules/CustomerBuildingList.vue';
import AnnualWorkScheduleList from '../views/AnnualWorkSchedules/AnnualWorkScheduleList.vue';
import AnnualWorkScheduleCreate from '../views/AnnualWorkSchedules/AnnualWorkScheduleCreate.vue';
import AnnualWorkScheduleEdit from '../views/AnnualWorkSchedules/AnnualWorkScheduleEdit.vue';

// 臨時作業
import TemporaryWorkList from '../views/TemporaryWorks/TemporaryWorkList.vue';
import TemporaryWorkCreate from '../views/TemporaryWorks/TemporaryWorkCreate.vue';
import TemporaryWorkEdit from '../views/TemporaryWorks/TemporaryWorkEdit.vue';
import TemporaryWorkDetail from '../views/TemporaryWorks/TemporaryWorkDetail.vue';

// ################################ 送付先類 ################################
// 請負業者用予定表
import MonthlyWorkVendorList from '../views/CoverLetters/VendorSchedules/MonthlyWorkVendorList.vue';
import VendorWorkMonthlyCalendarCreate from '../views/CoverLetters/VendorSchedules/VendorWorkMonthlyCalendarCreate.vue';
import VendorWorkMonthlyCalendarDetail from '../views/CoverLetters/VendorSchedules/VendorWorkMonthlyCalendarDetail.vue';
import VendorWorkMonthlyCalendarDetailPDF from '../views/CoverLetters/VendorSchedules/VendorWorkMonthlyCalendarDetailPDF.vue';
import VendorWorkMonthlyCalendarEdit from '../views/CoverLetters/VendorSchedules/VendorWorkMonthlyCalendarEdit.vue';

// 顧客用予定表
import CustomerCalendarList from '../views/CoverLetters/CustomerSchedules/CustomerCalendarList.vue';
import NonCreateCalendarBuildingList from '../views/CoverLetters/CustomerSchedules/NonCreateCalendarBuildingList.vue';
import CustomerCalendarCreate from '../views/CoverLetters/CustomerSchedules/Create/index.vue';
import CustomerCalendarDetail from '../views/CoverLetters/CustomerSchedules/Detail/index.vue';
import CustomerCalendarDetailJaPDF from '../views/CoverLetters/CustomerSchedules/Detail/CalendarDetailJaPDF.vue';
import CustomerCalendarEdit from '../views/CoverLetters/CustomerSchedules/Edit/index.vue';
// ################################ 送付先類 ################################

// ################################ 請求管理 ################################
// 顧客毎の差引残高の一覧
import CustomerBalances from '../views/Invoices/CustomerMoneyConfirms/CustomerBalances.vue';

// 年間予定作業と臨時作業の請求
import BillingList from '../views/Invoices/MonthlyBillings/BillingList.vue';
import NonBillingList from '../views/Invoices/MonthlyBillings/NonBillingList.vue';
import BillingCreate from '../views/Invoices/MonthlyBillings/Create/index.vue';
import BillingDetail from '../views/Invoices/MonthlyBillings/Detail/index.vue';
import BillingDetailJaPDF from '../views/Invoices/MonthlyBillings/Detail/BillingDetailJaPDF.vue';
import BillingDetailEnPDF from '../views/Invoices/MonthlyBillings/Detail/BillingDetailEnPDF.vue';
import BillingEdit from '../views/Invoices/MonthlyBillings/Edit/index.vue';

import BuildingWorkMonthlyBillingEmailCreate from '../views/Invoices/AnnualWorkScheduleBillings/BuildingWorkMonthlyBillingEmailCreate.vue';

// ################################ 請求管理 ################################

// ################################ 顧客金額管理 ################################
// 顧客金額情報管理（入金確認や顧客単位での請求書発行など）
import CustomerMoneyConditions from '../views/Invoices/CustomerMoneyConfirms/CustomerMoneyConditions.vue';
// ################################ 顧客金額管理 ################################

// ################################ システム運用 ################################
import CustomerPaymentConfirmReset from '../views/SystemOperations/CustomerPaymentConfirmReset.vue';
// ################################ システム運用 ################################

// ################################ 集計情報管理 ################################
import AggregateInfoMngMenu  from '../views/AggregateInfoMngs/AggregateInfoMngMenu.vue';
// 年間作業予定 売上管理
import SalesByData from '../views/AggregateInfoMngs/SalesMngs/SalesByData.vue';
// 臨時作業予定 売上管理
import TemporaryWorkSalesByData from '../views/AggregateInfoMngs/TemporaryWorkSalesMngs/TemporaryWorkSalesByData.vue';
// 全作業 売上管理
import TotalSalesByData from '../views/AggregateInfoMngs/TotalSalesMngs/TotalSalesByData.vue';
// 業者作業履歴
import VendorWorkHistory from '../views/AggregateInfoMngs/VendorWorkMngs/VendorWorkHistory.vue';

// 請求集計
// ################################ 集計情報管理 ################################

const routes = [
  { path: '/login', name: 'Login', component: Login },
  { path: '/sso-entry', name: 'SsoEntry', component: SsoEntryPage },

  // ホーム
  { path: '/home', name: 'Home', component: Home, meta: {requiresAuth: true} },

  // ユーザ情報ルート
  { path: '/users', name: 'UserList', component: UserList, meta: {requiresAuth: true} },
  { path: '/create-user', name: 'UserCreate', component: UserCreate, meta: {requiresAuth: true} },
  { path: '/user-edit/:id', name: 'UserEdit', component: UserEdit, props: true, meta: {requiresAuth: true} },
  { path: '/users/:id', name: 'UserDetail', component: UserDetail, props: true, meta: {requiresAuth: true} },

  // 顧客情報ルート
  { path: '/customers', name: 'CustomerList', component: CustomerList, requiresAuth: true, meta: {requiresAuth: true} },
  { path: '/create-customer', name: 'CustomerCreate', component: CustomerCreate, meta: {requiresAuth: true} },
  { path: '/customer-edit/:id', name: 'CustomerEdit', component: CustomerEdit, props: true, meta: {requiresAuth: true} },
  { path: '/customers/:id', name: 'CustomerDetail', component: CustomerDetail, props: true, meta: {requiresAuth: true} },

  // 顧客担当者情報ルート
  { path: '/customer-representatives', name: 'CustomerRepresentativeList', component: CustomerRepresentativeList, requiresAuth: true, meta: {requiresAuth: true} },
  { path: '/create-customer-representative', name: 'CustomerRepresentativeCreate', component: CustomerRepresentativeCreate, meta: {requiresAuth: true} },
  { path: '/customer-representative-edit/:id', name: 'CustomerRepresentativeEdit', component: CustomerRepresentativeEdit, props: true, meta: {requiresAuth: true} },
  { path: '/customer-representatives/:id', name: 'CustomerRepresentativeDetail', component: CustomerRepresentativeDetail, props: true, meta: {requiresAuth: true} },

  // 建物情報ルート
  { path: '/buildings', name: 'BuildingList', component: BuildingList, requiresAuth: true, meta: {requiresAuth: true} },
  { path: '/create-building', name: 'BuildingCreate', component: BuildingCreate, meta: {requiresAuth: true} },
  { path: '/building-edit/:id', name: 'BuildingEdit', component: BuildingEdit, props: true, meta: {requiresAuth: true} },
  { path: '/buildings/:id', name: 'BuildingDetail', component: BuildingDetail, props: true, meta: {requiresAuth: true} },

  // 建物種別情報ルート
  { path: '/building-types', name: 'BuildingTypeList', component: BuildingTypeList, requiresAuth: true, meta: {requiresAuth: true} },
  { path: '/create-building-type', name: 'BuildingTypeCreate', component: BuildingTypeCreate, meta: {requiresAuth: true} },
  { path: '/building-type-edit/:id', name: 'BuildingTypeEdit', component: BuildingTypeEdit, props: true, meta: {requiresAuth: true} },
  { path: '/building-types/:id', name: 'BuildingTypeDetail', component: BuildingTypeDetail, props: true, meta: {requiresAuth: true} },

  // 業者情報ルート
  { path: '/vendors', name: 'VendorList', component: VendorList, requiresAuth: true, meta: {requiresAuth: true} },
  { path: '/create-vendor', name: 'VendorCreate', component: VendorCreate, meta: {requiresAuth: true} },
  { path: '/vendor-edit/:id', name: 'VendorEdit', component: VendorEdit, props: true, meta: {requiresAuth: true} },
  { path: '/vendors/:id', name: 'VendorDetail', component: VendorDetail, props: true, meta: {requiresAuth: true} },

  // 業務区分情報ルート
  { path: '/business-classifications', name: 'BusinessClassificationList', component: BusinessClassificationList, requiresAuth: true, meta: {requiresAuth: true} },
  { path: '/create-business-classification', name: 'BusinessClassificationCreate', component: BusinessClassificationCreate, meta: {requiresAuth: true} },
  { path: '/business-classification-edit/:id', name: 'BusinessClassificationEdit', component: BusinessClassificationEdit, props: true, meta: {requiresAuth: true} },

  // 見積小分類情報ルート
  { path: '/estimate-subcategories', name: 'EstimateSubcategoryList', component: EstimateSubcategoryList, meta: {requiresAuth: true} },
  { path: '/estimate-subcategories/new', name: 'EstimateSubcategoryCreate', component: EstimateSubcategoryCreate, meta: {requiresAuth: true} },
  { path: '/estimate-subcategories/:id/edit', name: 'EstimateSubcategoryEdit', component: EstimateSubcategoryEdit, props: true, meta: {requiresAuth: true} },

  // 見積管理ルート
  { path: '/estimates', name: 'EstimateList', component: EstimateList, meta: {requiresAuth: true} },
  { path: '/estimates/approval-pending', name: 'EstimateApprovalPendingList', component: EstimateList, props: { approvalOnly: true }, meta: {requiresAuth: true, requiresAdmin: true} },
  { path: '/estimates/new', name: 'EstimateCreate', component: EstimateCreate, meta: {requiresAuth: true} },
  { path: '/estimates/:id/edit', name: 'EstimateEdit', component: EstimateEdit, props: true, meta: {requiresAuth: true} },
  { path: '/estimates/:id/work-conversion-preview', name: 'EstimateWorkConversionPreview', component: EstimateWorkConversionPreview, props: true, meta: {requiresAuth: true} },
  { path: '/estimates/:id', name: 'EstimateDetail', component: EstimateDetail, props: true, meta: {requiresAuth: true} },

  // 年間予定業務ルート
  { path: '/monthly-annual-work-schedules', name: 'MonthlyAnnualWorkScheduleList', component: MonthlyAnnualWorkScheduleList, requiresAuth: true, meta: {requiresAuth: true} },
  { path: '/work-buildings', name: 'CustomerBuildingList', component: CustomerBuildingList, requiresAuth: true, meta: {requiresAuth: true} },
  { path: '/annual-work-schedules/:building_id/:start_month', name: 'AnnualWorkScheduleList', component: AnnualWorkScheduleList, requiresAuth: true, meta: {requiresAuth: true} },
  { path: '/annual-work-schedule-create/:building_id/:start_month', name: 'AnnualWorkScheduleCreate', component: AnnualWorkScheduleCreate, requiresAuth: true, meta: {requiresAuth: true} },
  { path: '/annual-work-schedule-edit/:id/:building_id/:start_month', name: 'AnnualWorkScheduleEdit', component: AnnualWorkScheduleEdit, requiresAuth: true, meta: {requiresAuth: true} },

  // 臨時作業情報ルート
  { path: '/temporary-works', name: 'TemporaryWorkList', component: TemporaryWorkList, requiresAuth: true, meta: {requiresAuth: true} },
  { path: '/create-temporary-work', name: 'TemporaryWorkCreate', component: TemporaryWorkCreate, meta: {requiresAuth: true} },
  { path: '/temporary-work-edit/:id', name: 'TemporaryWorkEdit', component: TemporaryWorkEdit, props: true, meta: {requiresAuth: true} },
  { path: '/temporary-works/:id', name: 'TemporaryWorkDetail', component: TemporaryWorkDetail, props: true, meta: {requiresAuth: true} },

  // ################################ 送付先類 ################################
  // 請負業者用予定表
  { path: '/monthly-work-vendors', name: 'MonthlyWorkVendorList', component: MonthlyWorkVendorList, requiresAuth: true, meta: {requiresAuth: true} },
  { path: '/vendor-work-monthly-calendar-create/:vendor_id/:year/:month', name: 'VendorWorkMonthlyCalendarCreate', component: VendorWorkMonthlyCalendarCreate, requiresAuth: true, meta: {requiresAuth: true} },
  { path: '/vendor-work-monthly-calendar-detail/:vendor_id/:year/:month', name: 'VendorWorkMonthlyCalendarDetail', component: VendorWorkMonthlyCalendarDetail, requiresAuth: true, meta: {requiresAuth: true} },
  { path: '/vendor-work-monthly-calendar-detail-pdf/:year/:month', name: 'VendorWorkMonthlyCalendarDetailPDF', component: VendorWorkMonthlyCalendarDetailPDF, requiresAuth: true, meta: {requiresAuth: true} },
  { path: '/vendor-work-monthly-calendar-edit/:id/:vendor_id/:year/:month', name: 'VendorWorkMonthlyCalendarEdit', component: VendorWorkMonthlyCalendarEdit, requiresAuth: true, meta: {requiresAuth: true} },

  // 顧客用予定表
  { path: '/customer-calendars', name: 'CustomerCalendarList', component: CustomerCalendarList, requiresAuth: true, meta: {requiresAuth: true} },
  { path: '/non-create-calendar-billings', name: 'NonCreateCalendarBuildingList', component: NonCreateCalendarBuildingList, requiresAuth: true, meta: {requiresAuth: true} },
  { path: '/customer-calendar-create/:year/:month', name: 'CustomerCalendarCreate', component: CustomerCalendarCreate, requiresAuth: true, meta: {requiresAuth: true} },
  { path: '/customer-calendar-detail/:id/:year/:month', name: 'CustomerCalendarDetail', component: CustomerCalendarDetail, requiresAuth: true, meta: {requiresAuth: true} },
  { path: '/customer-calendar-detail-pdf/:year/:month', name: 'CustomerCalendarDetailJaPDF', component: CustomerCalendarDetailJaPDF, requiresAuth: true, meta: {requiresAuth: true} },
  { path: '/customer-calendar-edit/:id/:year/:month', name: 'CustomerCalendarEdit', component: CustomerCalendarEdit, requiresAuth: true, meta: {requiresAuth: true} },
  // ################################ 送付先類 ################################

  // ################################ 請求管理 ################################
  { path: '/customer-balances', name: 'CustomerBalances', component: CustomerBalances, requiresAuth: true, meta: {requiresAuth: true} },

  // 年間予定作業と臨時作業の合算請求
  { path: '/monthly-billings', name: 'BillingList', component: BillingList, requiresAuth: true, meta: {requiresAuth: true} },
  { path: '/monthly-non-billings', name: 'NonBillingList', component: NonBillingList, requiresAuth: true, meta: {requiresAuth: true} },
  { path: '/monthly-billing-create/:year/:month', name: 'BillingCreate', component: BillingCreate, requiresAuth: true, meta: {requiresAuth: true} },
  { path: '/monthly-billing-detail/:id/:year/:month', name: 'BillingDetail', component: BillingDetail, requiresAuth: true, meta: {requiresAuth: true} },
  { path: '/monthly-billing-detail-ja-pdf/:id', name: 'BillingDetailJaPDF', component: BillingDetailJaPDF, requiresAuth: true, meta: {requiresAuth: true} },
  { path: '/monthly-billing-detail-en-pdf/:id', name: 'BillingDetailEnPDF', component: BillingDetailEnPDF, requiresAuth: true, meta: {requiresAuth: true} },
  { path: '/monthly-billing-edit/:id/:year/:month', name: 'BillingEdit', component: BillingEdit, requiresAuth: true, meta: {requiresAuth: true} },
  
  // 年間作業予定請求
  { path: '/building-work-monthly-billing-email-create/:id/:building_id/:year/:month', name: 'BuildingWorkMonthlyBillingEmailCreate', component: BuildingWorkMonthlyBillingEmailCreate, requiresAuth: true, meta: {requiresAuth: true} },

  // 臨時作業請求
  // ################################ 請求管理 ################################

  // ################################ 顧客金額管理 ################################
  { path: '/customer-money-conditions', name: 'CustomerMoneyConditions', component: CustomerMoneyConditions, requiresAuth: true, meta: {requiresAuth: true} },
  // ################################ 顧客金額管理 ################################

  // ################################ システム運用 ################################
  { path: '/system/customer-payment-confirm-reset', name: 'CustomerPaymentConfirmReset', component: CustomerPaymentConfirmReset, requiresAuth: true, meta: {requiresAuth: true, seedSystemAdminOnly: true} },
  // ################################ システム運用 ################################

  // ################################ 集計情報管理 ################################
  { path: '/aggregate-info-mng-menu', name: 'AggregateInfoMngMenu', component: AggregateInfoMngMenu, requiresAuth: true, meta: {requiresAuth: true} },
  // 年間作業予定 売上管理
  { path: '/sales-by-data', name: 'SalesByData', component: SalesByData, requiresAuth: true, meta: {requiresAuth: true} },
  // 臨時作業 売上管理
  { path: '/temporary-work-sales-by-data', name: 'TemporaryWorkSalesByData', component: TemporaryWorkSalesByData, requiresAuth: true, meta: {requiresAuth: true} },
  // 全作業 売上管理
  { path: '/total-sales-by-data', name: 'TotalSalesByData', component: TotalSalesByData, requiresAuth: true, meta: {requiresAuth: true} },
  // 業者作業履歴
  { path: '/vendor-work-history', name: 'VendorWorkHistory', component: VendorWorkHistory, requiresAuth: true, meta: {requiresAuth: true} },

  // 請求集計
  // ################################ 集計情報管理 ################################
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

const hasStoredAuth = () => {
  const accessToken = localStorage.getItem('accessToken');
  const client = localStorage.getItem('client');
  const uid = localStorage.getItem('uid');

  return Boolean(accessToken && client && uid);
};

const isSeedSystemAdmin = () => {
  const role = String(store.state.userRole ?? localStorage.getItem('userRole') ?? '');
  const uid = localStorage.getItem('uid');

  return role === '999' && uid === 'admin@example.com';
};

router.beforeEach((to, from, next) => {
  const isLoggedIn = store.state.isLoggedIn || hasStoredAuth();
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin);
  const requiresSeedSystemAdmin = to.matched.some(record => record.meta.seedSystemAdminOnly);

  if (hasStoredAuth() && !store.state.isLoggedIn) {
    store.dispatch('setLoggedIn', true);
    store.dispatch('setUserName', localStorage.getItem('userName'));
    store.dispatch('setUserRole', localStorage.getItem('userRole'));
  }

  if (requiresAuth && !isLoggedIn) {
    next('/login'); // ログイン画面にリダイレクト
  } else if (requiresSeedSystemAdmin && !isSeedSystemAdmin()) {
    store.dispatch('setFlashMessage', { message: 'システム運用画面へのアクセス権限がありません', type: 'warning' });
    next('/home');
  } else if (requiresAdmin && !['0', '999'].includes(String(store.state.userRole))) {
    next('/home');
  } else {
    next(); // そのままルートに進む
  }
});

export default router;
